import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var PingIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsxs("g", {
                            clipPath: "url(#clip0_536_39431)",
                            children: [
                                _jsx("path", {
                                    d: "M12 14a2 2 0 100-4 2 2 0 000 4zM8 17a1 1 0 01-.71-.29 6.73 6.73 0 010-9.49 1.004 1.004 0 011.42 1.42 4.7 4.7 0 000 6.65A1 1 0 018 17z"
                                }),
                                _jsx("path", {
                                    d: "M4.49 19a1 1 0 01-.71-.29 9.5 9.5 0 010-13.42 1 1 0 111.41 1.42 7.5 7.5 0 000 10.58 1 1 0 01-.7 1.71zM16 17a1 1 0 01-.71-1.71 4.71 4.71 0 000-6.66 1 1 0 111.42-1.41 6.71 6.71 0 010 9.48 1 1 0 01-.71.3z"
                                }),
                                _jsx("path", {
                                    d: "M19.51 19a1 1 0 01-.7-.29 1 1 0 010-1.41 7.51 7.51 0 000-10.59 1 1 0 011.41-1.41 9.49 9.49 0 010 13.41 1 1 0 01-.71.29z"
                                })
                            ]
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "clip0_536_39431",
                                children: _jsx("path", {
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
PingIcon.isCarinaIcon = true;
export default PingIcon;
